import { render, staticRenderFns } from "./form_radio.vue?vue&type=template&id=65bd4622&scoped=true&lang=pug"
import script from "./form_radio.vue?vue&type=script&lang=js"
export * from "./form_radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd4622",
  null
  
)

export default component.exports